import React from 'react';

import styled, { css } from 'styled-components';

import { JRCIcon } from 'components/JRCIcon/JRCIcon';

const CSSWidgetSliderArrows = styled.div`
    position: absolute;
    pointer-events: none;
    inset: 0;
    display: flex;
    align-items: center;
`;

const left = css`
    left: 10px;
`;
const right = css`
    right: 10px;
`;
const arrow = css`
    position: absolute;
    border-radius: 40px;
    width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.5);
`;

const CSSWidgetSliderArrowLeft = styled.button`
    ${arrow}
    ${left}
`;
const CSSWidgetSliderArrowRight = styled.button`
    ${arrow}
    ${right}
`;

type SliderArrowsProps = {
    step: number;
    total: number;
    loop: boolean;
    onClickPrev: () => void;
    onClickNext: () => void;
};

export const SliderArrows = ({ step, total, loop, onClickPrev, onClickNext }: SliderArrowsProps) => {
    const showRight = loop || step < total - 1;
    const showLeft = loop || step > 0;
    return (
        <CSSWidgetSliderArrows>
            {showLeft && (
                <CSSWidgetSliderArrowLeft onClick={onClickPrev}>
                    <JRCIcon name="icon-angle-left" size={28} color="#fff" />
                </CSSWidgetSliderArrowLeft>
            )}
            {showRight && (
                <CSSWidgetSliderArrowRight onClick={onClickNext}>
                    <JRCIcon name="icon-angle-right" size={28} color="#fff" />
                </CSSWidgetSliderArrowRight>
            )}
        </CSSWidgetSliderArrows>
    );
};
